import api from './api';

export default {
  closeBreakingNews() {
    return api.get('/site/close-breaking-news/');
  },
};
